import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PlantanalysisShowcaseComponent } from './plantanalysis-showcase/plantanalysis-showcase.component';
import { PlantanalysistestComponent } from './plantanalysis-showcase/plantanalysistest/plantanalysistest.component';
import { PlantanalysistestresultComponent } from './plantanalysis-showcase/plantanalysistestresult/plantanalysistestresult.component';

const routes: Routes = [
  {path: '', component : PlantanalysisShowcaseComponent},
  { path: 'plant-analysis-test', component: PlantanalysistestComponent },
  { path: 'plant-analysis-test-result', component: PlantanalysistestresultComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
